import React, { useState, useEffect } from "react";

const CATEGORY_OPTIONS = [
  { key: 'TRITURATION', label: '💊 Trituration (Apr. 24)' },
  { key: 'MOTHER_TINCTURE', label: '🧪 Mother Tincture (Groups A-J)' },
  { key: 'BIOCHEMIC', label: '🌿 Biochemic (3X,6X,12X,30X)' },
  { key: 'GLOBULES_REF', label: '🍬 Globules & Bottle Reference' },
  { key: 'DILUTION_LIQUID', label: '💧 Dilution - Only Liquid' },
  { key: 'MEDICATED_GLOBULES', label: '🍬 Medicated Globules (Liquid/Globules)' },
  { key: 'SAC_LAC_DOSE', label: '✉️ Sac Lac Dose (100gm Sugar)' },
  { key: 'DW_DOSE', label: '🚰 Distilled Water Dose (D/W)' },
];

const TRITURATION_CATEGORIES = ['Category A', 'Category B', 'Category C', 'Category D', 'Category E', 'Category F'];
const MT_GROUPS = ['Group A', 'Group B', 'Group C', 'Group D', 'Group E', 'Group F', 'Group G', 'Group H', 'Group I', 'Group J'];

const defaultFormData = {
  category: "TRITURATION",
  medicineType: "Category A",
  dispensingForm: "TRITURATION",
  salesSize: "",
  salesUnit: "GM",
  rawMaterialConsumed: "",
  rawMaterialUnit: "GM",
  medicationConsumed: 0,
  medicationUnit: "ML",
  sellingPrice: "",
  drops: "",
  volume: "",
  doseCount: "",
  alternativeNotation: "",
  bottleSizes: "",
  description: "",
  bottleSize: "",
  bottleType: "Regular",
  alcoholQty: 0,
  globulesSize: "",
  globulesWeight: 0,
  labelSize: "",
  whiteCapNo: "",
  whiteCapQty: 0,
  dropperNo: "",
  dropperQty: 0,
  sealCapNo: "",
  sealCapQty: 0,
  pushNo: "",
  pushQty: 0,
  puriaQty: 0,
  waterQty: 0
};

const DispensingMasterForm = ({ show, onClose, heading, initialData, onSubmit, activeCategory, materials = [] }) => {
  const [formData, setFormData] = useState({ ...defaultFormData });

  const bottleSizes = (materials && materials.length > 0)
    ? [...new Set(materials.filter(m => m.material_type === 'bottle' && m.size_val).map(m => m.size_val))].sort((a, b) => parseFloat(a) - parseFloat(b))
    : ["5ML", "10ML", "15ML", "20ML", "30ML", "60ML", "100ML"];

  const whiteCapNos = (materials && materials.length > 0)
    ? [...new Set(materials.filter(m => m.material_type === 'white_cap' && m.number_val).map(m => m.number_val))].sort()
    : ["No. 1", "No. 2", "No. 3", "No. 4", "22 no", "25 no"];

  const sealCapNos = (materials && materials.length > 0)
    ? [...new Set(materials.filter(m => m.material_type === 'seal_cap' && m.number_val).map(m => m.number_val))].sort()
    : ["No. 1", "No. 2", "No. 3", "No. 4", "22 no", "25 no", "long cap"];

  const dropperSizes = (materials && materials.length > 0)
    ? [...new Set(materials.filter(m => m.material_type === 'dropper' && m.size_val).map(m => m.size_val))].sort((a, b) => parseFloat(a) - parseFloat(b))
    : ["5ML", "10ML", "15ML", "20ML", "30ML", "60ML", "100ML", "5ml dropper", "22 no", "25 no", "long dropper"];

  const pushNos = (materials && materials.length > 0)
    ? [...new Set(materials.filter(m => m.material_type === 'push' && m.number_val).map(m => m.number_val))].sort()
    : ["No. 1", "No. 2", "22 no", "25 no"];

  const labelSizes = (materials && materials.length > 0)
    ? [...new Set(materials.filter(m => m.material_type === 'label' && m.size_val).map(m => m.size_val))].sort((a, b) => parseFloat(a) - parseFloat(b))
    : ["5ML", "10ML", "15ML", "20ML", "22ML", "30ML", "60ML", "100ML", "130GM"];

  useEffect(() => {
    if (initialData) {
      setFormData({ ...defaultFormData, ...initialData });
    } else {
      const cat = (activeCategory && activeCategory !== 'ALL') ? activeCategory : 'TRITURATION';
      const defaultMedType = cat === 'TRITURATION' ? 'Category A' : (cat === 'MOTHER_TINCTURE' ? 'Group A' : (cat === 'BIOCHEMIC' ? '3X,6X,12X,30X' : 'Dilution'));
      const defaultForm = cat === 'TRITURATION' ? 'TRITURATION' : (cat === 'MOTHER_TINCTURE' ? 'LIQUID' : (cat === 'BIOCHEMIC' ? 'TABLETS' : 'LIQUID'));
      setFormData({ 
        ...defaultFormData, 
        category: cat,
        medicineType: defaultMedType,
        dispensingForm: defaultForm
      });
    }
  }, [initialData, show, activeCategory]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const updated = { ...prev, [name]: value };
      if (name === 'category') {
        if (value === 'TRITURATION') {
          updated.medicineType = 'Category A';
          updated.dispensingForm = 'TRITURATION';
          updated.salesUnit = 'GM';
        } else if (value === 'MOTHER_TINCTURE') {
          updated.medicineType = 'Group A';
          updated.dispensingForm = 'LIQUID';
          updated.salesUnit = 'ML';
        } else if (value === 'BIOCHEMIC') {
          updated.medicineType = '3X,6X,12X,30X';
          updated.dispensingForm = 'TABLETS';
          updated.salesUnit = 'GM';
        }
      }
      return updated;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  if (!show) return null;

  const cat = formData.category;

  const isTrituration = cat === 'TRITURATION';
  const isMotherTincture = cat === 'MOTHER_TINCTURE';
  const isBiochemic = cat === 'BIOCHEMIC';

  const showSalesSize = ['GLOBULES_REF', 'DILUTION_LIQUID', 'MEDICATED_GLOBULES', 'TRITURATION', 'MOTHER_TINCTURE', 'BIOCHEMIC'].includes(cat);
  const showRawMaterial = ['DILUTION_LIQUID', 'MEDICATED_GLOBULES', 'TRITURATION', 'MOTHER_TINCTURE', 'BIOCHEMIC'].includes(cat);
  const showDropsVolume = ['MEDICATED_GLOBULES', 'SAC_LAC_DOSE', 'DW_DOSE'].includes(cat);
  const showDoseCount = ['SAC_LAC_DOSE', 'DW_DOSE', 'TRITURATION'].includes(cat);
  const showAltNotation = cat === 'GLOBULES_REF';
  const showBottleSizes = cat === 'GLOBULES_REF';
  const showMedication = cat === 'MEDICATED_GLOBULES';
  const showSellingPrice = true;

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ background: "rgba(0,0,0,0.5)", zIndex: 1100 }}>
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content shadow-lg border-primary">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">{heading}</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body p-4">

              {/* Row 1: Category + Medicine Type */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label className="form-label fw-bold">Category <span className="text-danger">*</span></label>
                    <select className="form-select" name="category" value={formData.category} onChange={handleChange} required>
                      {CATEGORY_OPTIONS.map(opt => (
                        <option key={opt.key} value={opt.key}>{opt.label}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label className="form-label fw-bold">
                      {isTrituration ? 'Trituration Category' : (isMotherTincture ? 'JNM Group' : 'Medicine Type / Group')} <span className="text-danger">*</span>
                    </label>
                    {isTrituration ? (
                      <select 
                        className="form-select" 
                        name="medicineType" 
                        value={formData.medicineType} 
                        onChange={handleChange}
                        required
                      >
                        {TRITURATION_CATEGORIES.map(c => (
                          <option key={c} value={c}>{c}</option>
                        ))}
                      </select>
                    ) : isMotherTincture ? (
                      <select 
                        className="form-select" 
                        name="medicineType" 
                        value={formData.medicineType} 
                        onChange={handleChange}
                        required
                      >
                        {MT_GROUPS.map(g => (
                          <option key={g} value={g}>{g}</option>
                        ))}
                      </select>
                    ) : (
                      <input
                        type="text"
                        className="form-control"
                        name="medicineType"
                        value={formData.medicineType}
                        onChange={handleChange}
                        placeholder={cat === 'SAC_LAC_DOSE' ? 'e.g. Dilution (100gm Sugar)' : 'e.g. Dilution, Globules, 3X,6X,12X,30X'}
                        required
                      />
                    )}
                  </div>
                </div>
              </div>

              {/* Row 2: Dispensing Form + Selling Price */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label className="form-label fw-bold">Dispensing Form</label>
                    <input
                      type="text"
                      className="form-control"
                      name="dispensingForm"
                      value={formData.dispensingForm}
                      onChange={handleChange}
                      placeholder={isTrituration ? 'TRITURATION / PURIA' : 'e.g. LIQUID, GLOBULES, PURIA, TABLETS'}
                    />
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label className="form-label fw-bold text-success">Selling Price (₹) <span className="text-danger">*</span></label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control border-success fw-bold fs-15 text-success"
                      name="sellingPrice"
                      value={formData.sellingPrice}
                      onChange={handleChange}
                      placeholder="e.g. 60.00, 150.00"
                      required
                    />
                    <small className="text-muted">Direct sale / calculated amount for this size/category</small>
                  </div>
                </div>
              </div>

              {/* Row 3: Sales Size & Unit */}
              {showSalesSize && (
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <label className="form-label fw-bold">Sales Size</label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        name="salesSize"
                        value={formData.salesSize}
                        onChange={handleChange}
                        placeholder={isTrituration ? 'e.g. 10, 15, 20, 30, 60, 100' : 'e.g. 5, 10, 15, 30'}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <label className="form-label fw-bold">Sales Unit</label>
                      <select className="form-select" name="salesUnit" value={formData.salesUnit} onChange={handleChange}>
                        <option value="GM">GM</option>
                        <option value="ML">ML</option>
                        <option value="PURIA">PURIA</option>
                        <option value="DOSE">DOSE</option>
                      </select>
                    </div>
                  </div>
                </div>
              )}

              {/* Row 4: Raw Material Consumed */}
              {showRawMaterial && (
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <label className="form-label fw-bold">Raw Material / Medicine Consumed</label>
                      <input
                        type="number"
                        step="0.001"
                        className="form-control"
                        name="rawMaterialConsumed"
                        value={formData.rawMaterialConsumed}
                        onChange={handleChange}
                        placeholder="e.g. 10, 1.5, 4"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <label className="form-label fw-bold">Raw Material Unit</label>
                      <select className="form-select" name="rawMaterialUnit" value={formData.rawMaterialUnit} onChange={handleChange}>
                        <option value="GM">GM</option>
                        <option value="ML">ML</option>
                        <option value="PURIA">PURIA</option>
                      </select>
                    </div>
                  </div>
                </div>
              )}

              {/* Row: Dose Count (for Puria / Sac Lac / DW) */}
              {showDoseCount && (
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <div className="form-group">
                      <label className="form-label fw-bold">Dose Count / Description</label>
                      <input
                        type="text"
                        className="form-control"
                        name="doseCount"
                        value={formData.doseCount}
                        onChange={handleChange}
                        placeholder="e.g. 1 Puria, 1 sm dose, 30ml upto 2 dose"
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* SECTION: Packaging & Deductions */}
              <div className="card bg-light border-0 p-3 mt-3">
                <h6 className="text-primary fw-bold mb-3">📦 Packaging Materials & Stock Deductions</h6>
                
                <div className="row">
                  {/* Bottle */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Bottle Size</label>
                    <select className="form-select" name="bottleSize" value={formData.bottleSize} onChange={handleChange}>
                      <option value="">-- None --</option>
                      {bottleSizes.map(b => (
                        <option key={b} value={b}>{b}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-2 mb-3">
                    <label className="form-label">Bottle Type</label>
                    <select className="form-select" name="bottleType" value={formData.bottleType} onChange={handleChange}>
                      <option value="Regular">Regular</option>
                      <option value="L">L</option>
                    </select>
                  </div>

                  {/* Label */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Label Size</label>
                    <select className="form-select" name="labelSize" value={formData.labelSize} onChange={handleChange}>
                      <option value="">-- None --</option>
                      {labelSizes.map(l => (
                        <option key={l} value={l}>{l}</option>
                      ))}
                    </select>
                  </div>

                  {/* White Cap */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label">White Cap</label>
                    <select className="form-select" name="whiteCapNo" value={formData.whiteCapNo} onChange={handleChange}>
                      <option value="">-- None --</option>
                      {whiteCapNos.map(w => (
                        <option key={w} value={w}>{w}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="row">
                  {/* Dropper */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Dropper</label>
                    <select className="form-select" name="dropperNo" value={formData.dropperNo} onChange={handleChange}>
                      <option value="">-- None --</option>
                      {dropperSizes.map(d => (
                        <option key={d} value={d}>{d}</option>
                      ))}
                    </select>
                  </div>

                  {/* Seal Cap */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Seal Cap</label>
                    <select className="form-select" name="sealCapNo" value={formData.sealCapNo} onChange={handleChange}>
                      <option value="">-- None --</option>
                      {sealCapNos.map(s => (
                        <option key={s} value={s}>{s}</option>
                      ))}
                    </select>
                  </div>

                  {/* Alcohol Qty */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Alcohol (ml)</label>
                    <input
                      type="number"
                      step="0.1"
                      className="form-control"
                      name="alcoholQty"
                      value={formData.alcoholQty}
                      onChange={handleChange}
                      placeholder="0"
                    />
                  </div>

                  {/* Puria Count */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Puria Pcs</label>
                    <input
                      type="number"
                      step="1"
                      className="form-control"
                      name="puriaQty"
                      value={formData.puriaQty}
                      onChange={handleChange}
                      placeholder="0"
                    />
                  </div>
                </div>
              </div>

              {/* Description */}
              <div className="mt-3">
                <label className="form-label">Description / Remarks</label>
                <textarea
                  className="form-control"
                  name="description"
                  rows="2"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Additional formulation notes..."
                ></textarea>
              </div>

            </div>

            <div className="modal-footer bg-light">
              <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
              <button type="submit" className="btn btn-primary px-4">Save Rule</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DispensingMasterForm;
